<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'label.container' | translate"
  [readonly]="readonly"
  [loading]="loading"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [multi]="multi"
  [withAll]="multi"
/>
